/// <reference path="./index.d.ts" />
import * as $ from '@alife/alpha-jquery';

const csrf = $("input[name='_csrf_token_']").val();

/**
 * @description 获取商品的参加的优惠卷活动，2019年三月大促开始使用
 *
 * @export
 * @param {*} { publisherId, participateId, rangeType = 'product', applyPlace = 'detail', languageType = '', csrfToken }
 * @returns
 */
export function getProductCoupons<T>(params: PcCoupon.IQueryCouponParams): Promise<T> {
  const { publisherId, participateId, rangeType = 'product', applyPlace = 'detail', languageType = '', _csrf_token: csrfToken } = params;
  return $.ajax({
    url: '//marketing.alibaba.com/coupon/v2/querySpreadCouponListAjax.do',
    type: 'GET',
    dataType: 'jsonp',
    data: {
      _csrf_token: csrfToken,
      rangeType,
      channel: 'pc',
      applyPlace,
      participateId,
      publisherId,
      languageType,
    },
  }).done(res => res).fail(err => err);
}
/**
 * @description 领取卡券，从2019年3月大促启用
 * @param {number} couponId - 卡券id
 * @param {number} productId - 产品id
 * @returns {*}
 */
export function applyCoupon(couponId, productId, languageType) {
  const data = {
    couponId,
    productId,
    channel: 'pc',
    applyPlace: 0,
    languageType,
  };
  return $.ajax({
    url: '//marketing.alibaba.com/coupon/applyCouponAjax.do',
    type: 'GET',
    dataType: 'jsonp',
    data: {
      _csrf_token: csrf,
      json: JSON.stringify(data),
    },
  }).done(res => res).fail(err => err);
}

/**
 * Xman
 *
 * @export
 * @param {*} cb
 */
export function Xman(cb) {
  if (cb) {
    if (window.SCHD_COMS.SCXman) {
      cb(window.SCHD_COMS.SCXman);
    } else if (window.SCHD_COMS && window.SCHD_COMS.use) {
      window.SCHD_COMS.use(['xman'], () => {
        if (window.SCHD_COMS.SCXman) {
          cb(window.SCHD_COMS.SCXman);
        }
      });
    }
  }
}

